import React, { Component, Fragment } from "react";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import NumberFormat from "react-number-format";
import KurdishSoraniNumbersToWords from "kurdish-numbers-to-words/Sorani.js";
import n2wordsEN from "n2words/lib/i18n/AR.mjs";
export class RePrintTakeMoney extends Component {
  render() {
    const {
      change_Lang,
      primary_logo_bill,
      parawargrtn_view,
      footer_logo_bill,
      lang,
    } = this.props;
    let numberWordsSorani =
      parawargrtn_view && parawargrtn_view && parawargrtn_view.Amount !== ""
        ? KurdishSoraniNumbersToWords.convert(
            parawargrtn_view && parawargrtn_view && parawargrtn_view.Amount
          )
        : 0;
    let numWords1 =
      (parawargrtn_view && parawargrtn_view && parawargrtn_view.Amount) !==
        undefined &&
      (parawargrtn_view && parawargrtn_view && parawargrtn_view.Amount) !== null
        ? n2wordsEN(
            parseFloat(
              parawargrtn_view &&
                parawargrtn_view &&
                parawargrtn_view.Amount.toString().replace(/,/g, "")
            )
          )
        : 0;
    return (
      <Fragment>
        <div class="card product-page-main card-body">
          <div class="card-body p-0" id="yy">
            <div className="fk">
              <div class="row">
                <div class="col-md-12  ">
                  <img
                    src={primary_logo_bill}
                    alt="logo"
                    className="img-fluid img-responsive"
                    style={{
                      position: "relative",
                      top: -15,
                      width: "100%",
                    }}
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <p
                    style={{
                      fontSize: "22px",
                      color: "#2c1947",
                      textAlign: "right",
                      fontWeight: "bold",
                    }}
                    class=" text-uppercase"
                  >
                    &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
                    <Time
                      value={parawargrtn_view && parawargrtn_view.createdAt}
                      format="YYYY-MM-DD"
                      style={{
                        fontSize: "22px",
                        color: "#2c1947",
                        fontWeight: "bold",
                      }}
                    />
                  </p>
                </div>
                <div class="col-md-6 d-flex justify-content-center">
                  <p
                    style={{
                      fontSize: "24px",
                      color: "#2c1947",
                      fontWeight: "bolder",
                    }}
                    class={`d-flex justify-content-center text-uppercase ${
                      lang !== "en" ? "fk" : "fkp"
                    } `}
                  >
                    {change_Lang("Repayment bills")} (
                    {change_Lang(parawargrtn_view && parawargrtn_view.type)})
                  </p>
                </div>
                <div class="col-md-3 text-right">
                  <p
                    style={{
                      fontSize: "22px",
                      color: "#2c1947",
                      fontWeight: "bold",
                    }}
                    class=" text-uppercase"
                  >
                    {change_Lang("in_invoice")}#&nbsp;
                    {parawargrtn_view && parawargrtn_view.invoice_No}&nbsp;
                  </p>
                </div>
              </div>
              {/* first row */}
              <div
                class="row mt-3"
                style={{ width: "100%", backgroundColor: "#f4f4f6" }}
              >
                <div class="col-md-3 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    وەرگر/المستلم :
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-center">
                  {" "}
                  <label
                    className="fk col-form-label d-flex justify-content-start"
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                  >
                    {parawargrtn_view && parawargrtn_view.Money_recive}
                  </label>
                </div>
                <div class="col-md-3 d-flex justify-content-end">
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fkb"
                  >
                    : Receipt from
                  </label>
                </div>
              </div>
              {/* second row */}
              <div
                class="row"
                style={{ width: "100%", backgroundColor: "white" }}
              >
                <div class="col-md-3 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    بڕی پارە / مبلغ و قدره :
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-center">
                  {" "}
                  <NumberFormat
                    displayType="text"
                    thousandSeparator={true}
                    value={parawargrtn_view && parawargrtn_view.Amount}
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    className="col-form-label"
                    prefix={`${
                      parawargrtn_view && parawargrtn_view.currency === "dolar"
                        ? "$"
                        : "ID"
                    }`}
                  />
                  &nbsp;&nbsp;
                  <span
                    className="fk"
                    style={{ fontWeight: "bold", marginTop: "12px" }}
                  >
                    {" "}
                    {lang === "krd" ? numberWordsSorani : numWords1}&nbsp;
                    {`${
                      parawargrtn_view && parawargrtn_view.currency === "dolar"
                        ? "دۆلاری ئەمریکی"
                        : "دینار"
                    }`}
                    {change_Lang("Only")}
                  </span>
                </div>
                <div class="col-md-3 d-flex justify-content-end">
                  {" "}
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fkb"
                  >
                    : Amount
                  </label>
                </div>
              </div>
              {/* third row */}
              <div
                class="row"
                style={{ width: "100%", backgroundColor: "#f4f4f6" }}
              >
                <div class="col-md-3 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    لە بڕی / وذلك عن :
                  </label>
                </div>
                <div class="col-md-8 d-flex justify-content-center">
                  {parawargrtn_view &&
                  parawargrtn_view.type !== "investor" &&
                  parawargrtn_view &&
                  parawargrtn_view.instead_of === "" ? (
                    <span
                      className="fk d-flex justify-content-center mt-2"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        textAlign: "justify",
                      }}
                    >
                      {parawargrtn_view &&
                      parawargrtn_view.type !== "Monthly rent invoice" ? (
                        <>
                          {change_Lang(
                            parawargrtn_view && parawargrtn_view.type
                          )}{" "}
                          (
                          {change_Lang(
                            parawargrtn_view && parawargrtn_view.property
                          )}
                          )&nbsp;
                          {change_Lang("from")}
                          &nbsp;({parawargrtn_view && parawargrtn_view.place})
                          &nbsp;
                          {change_Lang("Number")}&nbsp;({parawargrtn_view.num})
                        </>
                      ) : (
                        <>
                          {change_Lang(
                            parawargrtn_view && parawargrtn_view.type
                          )}{" "}
                          (
                          {change_Lang(
                            parawargrtn_view && parawargrtn_view.property
                          )}
                          )&nbsp;
                          {change_Lang("from")}
                          &nbsp;({parawargrtn_view && parawargrtn_view.place})
                          &nbsp;
                          {change_Lang("Number")}&nbsp;({parawargrtn_view.num}
                          )&nbsp;
                          {change_Lang("from")}&nbsp;
                          {parawargrtn_view && parawargrtn_view.from}
                          &nbsp;
                          {change_Lang("to")}&nbsp;
                          {parawargrtn_view && parawargrtn_view.to}
                        </>
                      )}
                    </span>
                  ) : (
                    <span
                      className="fk d-flex justify-content-center mt-2"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        textAlign: "justify",
                      }}
                    >
                      {parawargrtn_view && parawargrtn_view.instead_of}
                    </span>
                  )}
                </div>
                <div class="col-md-1 d-flex justify-content-end">
                  {" "}
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fkb"
                  >
                    : For
                  </label>
                </div>
              </div>
              {/* five row */}
              <div
                class="row"
                style={{ width: "100%", backgroundColor: "white" }}
              >
                <div class="col-md-3 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    پارەدەر / الدافع :
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-center">
                  {" "}
                  <label
                    className="fk col-form-label"
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                  >
                    {parawargrtn_view && parawargrtn_view.Money_provider}
                  </label>
                </div>
                <div class="col-md-3 d-flex justify-content-end">
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label"
                  >
                    : Receptor
                  </label>
                </div>
              </div>
              {/* note */}
              <div
                class="row"
                style={{ width: "100%", backgroundColor: "#f4f4f6" }}
              >
                <div class="col-md-3 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    تێبینی / الملاحظات :
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-center">
                  {" "}
                  <label
                    className="fk col-form-label"
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                  >
                    {parawargrtn_view && parawargrtn_view.note}
                  </label>
                </div>
                <div class="col-md-3 d-flex justify-content-end">
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label"
                  >
                    : Note
                  </label>
                </div>
              </div>
              {/* six row */}
              <br />
              <br />
              <div class="row">
                <div class="col-md-6 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    (پارەدەر)&nbsp;واژوو / توقيع
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-end">
                  {" "}
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    (پارەوەرگر)&nbsp;واژوو / توقيع
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "18px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                    class=" col-form-label fk"
                  >
                    {parawargrtn_view && parawargrtn_view.Money_provider}
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-end">
                  {" "}
                  <label
                    style={{
                      fontSize: "18px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                    class=" col-form-label fk"
                  >
                    {parawargrtn_view && parawargrtn_view.Money_recive}
                  </label>
                </div>
              </div>
              <br />
              <br />
              {/* footer */}
              <div
                className="row"
                style={{
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "65px",
                  background: "black",
                }}
              >
                <div className="col-4 d-flex justify-content-start">
                  <span
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "18px",
                      textAlign: "center",
                    }}
                    className="fk"
                  >
                    {parawargrtn_view && parawargrtn_view.branchId.adress}
                  </span>
                  &nbsp;
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "22px",
                    }}
                  >
                    <i class="fa-solid fa-location-dot mr-3"></i>
                  </span>
                </div>
                <div className="col-4 d-flex justify-content-center">
                  <span
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginLeft: "0px",
                      textAlign: "center",
                    }}
                  >
                    MRC@hotmail.com
                    <br />
                    www.MRC.com
                  </span>{" "}
                  &nbsp;
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "22px",
                    }}
                  >
                    <i class="fa-solid fa-envelope mt-3 mr-3"></i>
                  </span>
                </div>
                <div className="col-3 d-flex justify-content-end">
                  <span
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginLeft: "0px",
                    }}
                  >
                    {parawargrtn_view &&
                      parawargrtn_view.branchId.adressNumber1}
                    <br />
                    {parawargrtn_view &&
                      parawargrtn_view.branchId.adressNumber2}
                  </span>{" "}
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "22px",
                    }}
                  >
                    <i class="fa-solid fa-phone mt-3  mr-3"></i>
                  </span>
                </div>
              </div>
            </div>
            <br />
            <hr style={{ border: "1px dashed black" }} />
            {/* Second Invoice */}
            <div className="fk">
              <div class="row">
                <div class="col-md-12  ">
                  <img
                    src={primary_logo_bill}
                    alt="logo"
                    className="img-fluid img-responsive"
                    style={{
                      position: "relative",
                      top: 0,
                      width: "100%",
                    }}
                  />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-3">
                  <p
                    style={{
                      fontSize: "22px",
                      color: "#2c1947",
                      textAlign: "right",
                      fontWeight: "bold",
                    }}
                    class=" text-uppercase"
                  >
                    &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
                    <Time
                      value={parawargrtn_view && parawargrtn_view.createdAt}
                      format="YYYY-MM-DD"
                      style={{
                        fontSize: "22px",
                        color: "#2c1947",
                        fontWeight: "bold",
                      }}
                    />
                  </p>
                </div>
                <div class="col-md-6 d-flex justify-content-center">
                  <p
                    style={{
                      fontSize: "24px",
                      color: "#2c1947",
                      fontWeight: "bolder",
                    }}
                    class={`d-flex justify-content-center text-uppercase ${
                      lang !== "en" ? "fk" : "fkp"
                    } `}
                  >
                    {change_Lang("Repayment bills")} (
                    {change_Lang(parawargrtn_view && parawargrtn_view.type)})
                  </p>
                </div>
                <div class="col-md-3 text-right">
                  <p
                    style={{
                      fontSize: "22px",
                      color: "#2c1947",
                      fontWeight: "bold",
                    }}
                    class=" text-uppercase"
                  >
                    {change_Lang("in_invoice")}#&nbsp;
                    {parawargrtn_view && parawargrtn_view.invoice_No}&nbsp;
                  </p>
                </div>
              </div>
              {/* first row */}
              <div
                class="row mt-3"
                style={{ width: "100%", backgroundColor: "#f4f4f6" }}
              >
                <div class="col-md-3 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    وەرگر/المستلم :
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-center">
                  {" "}
                  <label
                    className="fk col-form-label d-flex justify-content-start"
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                  >
                    {parawargrtn_view && parawargrtn_view.Money_recive}
                  </label>
                </div>
                <div class="col-md-3 d-flex justify-content-end">
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fkb"
                  >
                    : Receipt from
                  </label>
                </div>
              </div>
              {/* second row */}
              <div
                class="row"
                style={{ width: "100%", backgroundColor: "white" }}
              >
                <div class="col-md-3 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    بڕی پارە / مبلغ و قدره :
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-center">
                  {" "}
                  <NumberFormat
                    displayType="text"
                    thousandSeparator={true}
                    value={parawargrtn_view && parawargrtn_view.Amount}
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    className="col-form-label"
                    prefix={`${
                      parawargrtn_view && parawargrtn_view.currency === "dolar"
                        ? "$"
                        : "ID"
                    }`}
                  />
                  &nbsp;&nbsp;
                  <span
                    className="fk"
                    style={{ fontWeight: "bold", marginTop: "12px" }}
                  >
                    {" "}
                    {lang === "krd" ? numberWordsSorani : numWords1}&nbsp;
                    {`${
                      parawargrtn_view && parawargrtn_view.currency === "dolar"
                        ? "دۆلاری ئەمریکی"
                        : "دینار"
                    }`}
                    {change_Lang("Only")}
                  </span>
                </div>
                <div class="col-md-3 d-flex justify-content-end">
                  {" "}
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fkb"
                  >
                    : Amount
                  </label>
                </div>
              </div>
              {/* third row */}
              <div
                class="row"
                style={{ width: "100%", backgroundColor: "#f4f4f6" }}
              >
                <div class="col-md-3 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    لە بڕی / وذلك عن :
                  </label>
                </div>
                <div class="col-md-8 d-flex justify-content-center">
                  {parawargrtn_view &&
                  parawargrtn_view.type !== "investor" &&
                  parawargrtn_view &&
                  parawargrtn_view.instead_of === "" ? (
                    <span
                      className="fk d-flex justify-content-center mt-2"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        textAlign: "justify",
                      }}
                    >
                      {parawargrtn_view &&
                      parawargrtn_view.type !== "Monthly rent invoice" ? (
                        <>
                          {change_Lang(
                            parawargrtn_view && parawargrtn_view.type
                          )}{" "}
                          (
                          {change_Lang(
                            parawargrtn_view && parawargrtn_view.property
                          )}
                          )&nbsp;
                          {change_Lang("from")}
                          &nbsp;({parawargrtn_view && parawargrtn_view.place})
                          &nbsp;
                          {change_Lang("Number")}&nbsp;({parawargrtn_view.num})
                        </>
                      ) : (
                        <>
                          {change_Lang(
                            parawargrtn_view && parawargrtn_view.type
                          )}{" "}
                          (
                          {change_Lang(
                            parawargrtn_view && parawargrtn_view.property
                          )}
                          )&nbsp;
                          {change_Lang("from")}
                          &nbsp;({parawargrtn_view && parawargrtn_view.place})
                          &nbsp;
                          {change_Lang("Number")}&nbsp;({parawargrtn_view.num}
                          )&nbsp;
                          {change_Lang("from")}&nbsp;
                          {parawargrtn_view && parawargrtn_view.from}
                          &nbsp;
                          {change_Lang("to")}&nbsp;
                          {parawargrtn_view && parawargrtn_view.to}
                        </>
                      )}
                    </span>
                  ) : (
                    <span
                      className="fk d-flex justify-content-center mt-2"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        textAlign: "justify",
                      }}
                    >
                      {parawargrtn_view && parawargrtn_view.instead_of}
                    </span>
                  )}
                </div>
                <div class="col-md-1 d-flex justify-content-end">
                  {" "}
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fkb"
                  >
                    : For
                  </label>
                </div>
              </div>
              {/* five row */}
              <div
                class="row"
                style={{ width: "100%", backgroundColor: "white" }}
              >
                <div class="col-md-3 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    پارەدەر / الدافع :
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-center">
                  {" "}
                  <label
                    className="fk col-form-label"
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                  >
                    {parawargrtn_view && parawargrtn_view.Money_provider}
                  </label>
                </div>
                <div class="col-md-3 d-flex justify-content-end">
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label"
                  >
                    : Receptor
                  </label>
                </div>
              </div>
              {/* note */}
              <div
                class="row"
                style={{ width: "100%", backgroundColor: "#f4f4f6" }}
              >
                <div class="col-md-3 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    تێبینی / الملاحظات :
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-center">
                  {" "}
                  <label
                    className="fk col-form-label"
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                  >
                    {parawargrtn_view && parawargrtn_view.note}
                  </label>
                </div>
                <div class="col-md-3 d-flex justify-content-end">
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label"
                  >
                    : Note
                  </label>
                </div>
              </div>
              {/* six row */}
              <br />
              <div class="row mt-3">
                <div class="col-md-6 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "18px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    (پارەدەر)&nbsp;واژوو / توقيع
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-end">
                  {" "}
                  <label
                    style={{
                      fontSize: "20px",
                      color: "black",
                    }}
                    class=" col-form-label fk"
                  >
                    (پارەوەرگر)&nbsp;واژوو / توقيع
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-start">
                  {" "}
                  <label
                    style={{
                      fontSize: "18px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                    class=" col-form-label fk"
                  >
                    {parawargrtn_view && parawargrtn_view.Money_provider}
                  </label>
                </div>
                <div class="col-md-6 d-flex justify-content-end">
                  {" "}
                  <label
                    style={{
                      fontSize: "18px",
                      color: "black",
                      fontWeight: "bold",
                    }}
                    class=" col-form-label fk"
                  >
                    {parawargrtn_view && parawargrtn_view.Money_recive}
                  </label>
                </div>
              </div>
              <br />
              {/* footer */}
              <div
                className="row"
                style={{
                  position: "fixed",
                  bottom: 0,
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "65px",
                  background: "black",
                }}
              >
                <div className="col-4 d-flex justify-content-start">
                  <span
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "18px",
                      textAlign: "center",
                    }}
                    className="fk"
                  >
                    {parawargrtn_view && parawargrtn_view.branchId.adress}
                  </span>
                  &nbsp;
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "22px",
                    }}
                  >
                    <i class="fa-solid fa-location-dot mr-3"></i>
                  </span>
                </div>
                <div className="col-4 d-flex justify-content-center">
                  <span
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginLeft: "0px",
                      textAlign: "center",
                    }}
                  >
                    MRC@hotmail.com
                    <br />
                    www.MRC.com
                  </span>{" "}
                  &nbsp;
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "22px",
                    }}
                  >
                    <i class="fa-solid fa-envelope mt-3 mr-3"></i>
                  </span>
                </div>
                <div className="col-3 d-flex justify-content-end">
                  <span
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "18px",
                      marginLeft: "0px",
                    }}
                  >
                    {parawargrtn_view &&
                      parawargrtn_view.branchId.adressNumber1}
                    <br />
                    {parawargrtn_view &&
                      parawargrtn_view.branchId.adressNumber2}
                  </span>{" "}
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "22px",
                    }}
                  >
                    <i class="fa-solid fa-phone mt-3  mr-3"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    parawargrtn_view: state.InvoiceReducer.parawargrtn_view,
    index_all_takemoney: state.InvoiceReducer.index_all_takemoney,
    primary_logo_bill: state.HelperReducer.primary_logo_bill,
    footer_logo_bill: state.HelperReducer.footer_logo_bill,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RePrintTakeMoney);
